export default [
  {
    path: '/course-schedule-sign',
    name: 'course-schedule-sign',
    component: () => import(/* webpackChunkName: "course-schedule-sign" */ './course-schedule-sign/course-schedule-sign.vue'),
    meta: {
      menuCode: 'pcCourseSign',
      menuName: '点名记录',
    },
  },
  {
    path: '/course-sign-detail/:id',
    name: 'course-sign-detail',
    component: () => import(/* webpackChunkName: "course-sign-detail" */ './course-schedule-sign/course-sign-detail.vue'),
    meta: {
      cachePage: ['/course-schedule-sign'],
      menuName: '点名记录详情',
    },
  },
  // {
  //   path: '/visual-timetable',
  //   name: 'visual-timetable',
  //   component: () => import(/* webpackChunkName: "visual-timetable" */ './visual-timetable/visual-timetable.vue'),
  //   meta: {
  //     menuCode: 'pcCourseSyllabus',
  //     menuName: '课表管理',
  //   },
  // },
  {
    path: '/course-arrange-management',
    name: 'course-arrange-management',
    component: () => import(/* webpackChunkName: "course-arrange-management" */ './visual-timetable/course-arrange-management.vue'),
    meta: {
      menuCode: 'pcCourseSyllabus',
      menuName: '课表管理',
    },
  },
  {
    path: '/course-arrange-detail/:id',
    name: 'course-arrange-detail',
    component: () => import(/* webpackChunkName: "course-arrange-detail" */ './visual-timetable/course-arrange-detail.vue'),
    meta: {
      // noCache: true,
      cachePage: ['/course-arrange-management'],
      menuName: '排课详情',
    },
  },
  {
    path: '/student-management',
    name: 'student-management',
    component: () => import(/* webpackChunkName: "student-management" */ './student-management/index.vue'),
    meta: {
      menuCode: 'pcStudentManage',
      menuName: '学员管理',
    },
  },
  {
    path: '/student-detail/:id',
    name: 'student-detail',
    component: () => import(/* webpackChunkName: "student-detail" */ './student-management/detail/student-detail.vue'),
    meta: {
      cachePage: ['/student-management'],
      menuName: '学员详情',
    },
  },
  {
    path: '/class-management',
    name: 'class-management',
    component: () => import(/* webpackChunkName: "class-management" */ './class-management/class-management.vue'),
    meta: {
      menuCode: 'pcClassManage',
      menuName: '班级管理',
    },
  },
  {
    path: '/class-detail/:id',
    name: 'class-detail',
    component: () => import(/* webpackChunkName: "class-detail" */ './class-management/detail/class-detail.vue'),
    meta: {
      cachePage: ['/class-management'],
      menuName: '班级详情',
    },
  },
];
